import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { AgendaToggleService } from 'src/app/services/agenda-toggle.service';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventDetails } from '../../models/events.model';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'transflo-scheduler-agenda',
  templateUrl: './scheduler-agenda.component.html'
})
export class SchedulerAgendaComponent implements OnInit {
  @ViewChild('content') private content: TemplateRef<any>;
  flagIsActive: boolean;
  normalAgendaIsActive: boolean;
  currentEvent: EventDetails;
  eventId: number = 0;
  basicPopulateAgenda = true;

  constructor(
    private agendaToggleService: AgendaToggleService,
    config: NgbModalConfig,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute
  ) {
    config.backdrop = 'static';
  }

  ngOnInit(): void {
    this.agendaToggleService.isFlaggedAgenda
      .subscribe(value => {
        this.flagIsActive = value;
      });
    this.agendaToggleService.isNormalAgenda
      .subscribe(value => {
        this.normalAgendaIsActive = value;
      });

    const appParams = this.activatedRoute.snapshot.url[0].parameters;
    if (Object.keys(appParams).length !== 0 && appParams.hasOwnProperty('fleetId') &&
      appParams.hasOwnProperty('token') && appParams.hasOwnProperty('eventId')) {
      this.eventId = Number.parseInt(appParams.eventId);
    }
  }

  open(content: any): void {
    this.modalService.open(content, { centered: true, backdropClass: 'scheduler-modal' });
  }

  closeModal(shouldCloseModal: boolean): void {
    if (shouldCloseModal) {
      this.modalService.dismissAll();
    }
  }

  openUpdateEventModal($event: any): void {
    if ($event && $event.shouldOpenModal) {
      this.currentEvent = $event.event;
      this.open(this.content);
    }
  }

}
